<template>
    <!-- Content -->
    <section id="content" class="content tvapp-cont">
        <!-- Content Header -->
        <!--<div class="content-header sub-visual">-->
        <!--<div class="sub-visual-bg"></div>-->
        <!--<div class="in-sec">-->
        <!--<div class="tit-wrap centered-c">-->
        <!--<h2 class="tit-h2">{{ $t('sdp.menu.gnb.tvapp') }}</h2>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!-- //Content Header -->

        <!-- Content Body -->
        <div class="content-body">
            <!-- 탭메뉴 -->
            <div class="tab-type1-wrap in-sec">
                <nav class="tab-nav tab-type1 tab-responsive tab-applist blind-selected-wrap"><!-- 웹접근성 논리적인구조 : 선택된탭제목 목차텍스트로 내보내기 JS처리 -->
                    <ul role="tablist">
                        <li role="presentation" :class="{'is-active' : isTabActive('')}" v-show="appCateList.length > 0">
                            <a href="javascript:;" role="tab" aria-selected="true" @click="goAllSearch()">
                                <span class="tit">{{ $t("sdp.mypage.message.tabbuyall") }}</span>
                            </a>
                        </li>
                        <li v-for="item in appCateList" role="presentation" :class="{'is-active' : isTabActive(item.catCode)}">
                            <a href="javascript:;" role="tab" aria-selected="false" @click="goTabSearch(item.catCode, item.catName)">
                                <span class="tit">{{ item.catName }}<em class="label-type2">{{ item.cnt }}</em></span>
                            </a>
                        </li>
                    </ul>
                </nav>
                <!-- SCREENSHOTS -->
                <div class="view-section view-screenshots" v-if="loadingYn == 'N'">
                    <!--<h4 class="tit-h4">{{ $t("sdp.store.message.screenshot") }}</h4>-->
                    <div class="swiper-wrap swiper-screenshots" v-for="item in prodInfo">
                        <!-- 상세그룹  -->
                        <!--  대체텍스트 형식 : alt="[앱 제목] + Screenshots + [Index]" -->
                        <div class="swiper-container">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide" v-for="(screenShot, index) in screenShotList">
                                    <!-- 2023.07.11 송준형 : REQSDP-1851 - [pcmall]앱 상세정보 영역 변경_pc_webiste -->
                                    <!-- 2024.06.14 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년 -->
                                    <a href="javascript:;" :data-src="screenShot.orgFilePath" onclick="zommer.open(this); return $('.zommer-body .zommer-img').attr('tabindex', '-1').focus();"><img :src="screenShot.orgFilePath" :alt="$t('gwa.alt.tvapp.wa_etc_3', { var1 : item.appName, var2 : (index+1) })" /></a>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-button-prev"></div>
                        <div class="swiper-button-next"></div>
                    </div>
                </div>
                <!-- //SCREENSHOTS -->
                <div class="section-body" v-if="loadingYn == 'Y'">
                    <div class="loading-wrap">
                        <div class="loading"><img src="/img/cmn/loading.png" :alt="$t('gwa.alt.common.wa_etc_1')"></div>
                    </div>
                </div>
                <div class="tab-body" v-else>
                    <!-- 상세섹션 -->
                    <section class="section section-category outline" v-for="item in prodInfo">
                        <p class="blind blind-selected dv-pc-only"></p><!-- 선택된탭제목 목차텍스트로 가져오기 -->
                        <div class="section-body">
                            <!-- 앱상세 전체영역 -->
                            <div class="view-app-wrap" :appName="item.appName">
                                <!-- 주요정보 -->
                                <!-- 고도화 ver2 : caption 접근성문구 수정 -->
                                <!-- 2023.02.14 Mod =s-->
                                <div class="view-header pc">
                                    <!-- <div class="tit-wrap">

                                    </div> -->
                                    <div class="tbl-wrap">
                                        <p class="thumbnail"><img :src="item.bigIconFile" :alt="$t('gwa.alt.tvapp.wa_etc_1', { var1 : item.appName })" onerror="imageResize.reset(this)" /></p>
                                        <div class="tbl-type2">
                                            <div class="section-header">
                                                <!-- S : 2022.02.15 Add - 모바일용 앱 아이콘 추가(view-header 영역 이미지값 동일하게 적용) -->
                                                <div class="appIcon">
                                                    <img :src="item.bigIconFile" :alt="$t('gwa.alt.tvapp.wa_etc_1', { var1 : item.appName })" onerror="imageResize.reset(this)" />
                                                </div>
                                                <!-- E : 2022.02.15 Add - 모바일용 앱 아이콘 추가(view-header 영역 이미지값 동일하게 적용) -->
                                                <div class="inner">
                                                    <!--
                                                        고도화 ver2 - 카테고리별 아이콘 추가
                                                        ico-category1 게임
                                                        ico-category2 엔터테인먼트
                                                        ico-category3 생활
                                                        ico-category4 어학/교육
                                                        ico-category5 뉴스/정보
                                                    -->
                                                    <!-- 2024.06.13 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년 -->
                                                    <h3 class="tit-h3 tvappTitle"><span role="text">{{ item.appName }} <i v-for="feat in featureList" :class="'ico ico-category'+feat.icoType">{{ getFeatIconText(feat.icoType) }}</i></span></h3> <!-- 2019.08.07 Mod 홍병기K (tvappTitle 추가 모바일에서 text겹침) -->
                                                </div>
                                            </div>
                                            <table>
                                                <colgroup>
                                                    <col width="*">
                                                    <col width="21%">
                                                    <col width="23%">
                                                    <col width="18%">
                                                    <col width="20%">
                                                </colgroup>
                                                <caption>
                                                    <strong>{{ $t("gwa.alt.common.wa_caption_5", { var1 : item.appName }) }}</strong>
                                                    <p>{{ $t("gwa.alt.common.wa_summary_5_pc") }}</p>
                                                </caption>
                                                <thead>
                                                <tr>
                                                    <th scope="col">{{ $t("sdp.store.message.age") }}</th>
                                                    <th scope="col">{{ $t("sdp.store.message.category") }}</th>
                                                    <th scope="col">{{ $t("sdp.store.message.updated") }}</th>
                                                    <th scope="col">{{ $t("sdp.store.message.version") }}</th>
                                                    <th scope="col">{{ $t("sdp.store.message.size") }}</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td>
                                                        <p class="tb_ctxt" v-if="cntryCode == 'BR' && item.age == '4'">{{ item.ageBr }}</p>
                                                        <p class="tb_ctxt" v-else>{{ item.appAge }}</p>
                                                    </td>
                                                    <td>
                                                        <p class="tb_ctxt">{{ item.cat }}</p>
                                                    </td>
                                                    <td>
                                                        <p class="tb_ctxt">{{ item.rcntAprlDate }}</p>
                                                    </td>
                                                    <td>
                                                        <p class="tb_ctxt">{{ item.appVer }}</p>
                                                    </td>
                                                    <td>
                                                        <p class="tb_ctxt mb" v-html="fileSizeReplace(item.appFileSize)"></p>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <!-- <div class="explain-footer">
                                            <div class="bul bul-bill">
                                                <p>국가에 따라 일부 모델은 서비스가 지원되지 않을 수 있으며, 모델에 따라 지원되는 앱이 다를 수 있습니다.</p>
                                            </div>
                                        </div> 2022.06.21 Del -->
                                    </div>
                                    <div class="starRating-cate">
                                        <div class="js starRating-label" role="text" aria-valuemax="5" aria-valuemin="0" :aria-valuenow="appStar(item.avgSscr)" :aria-label="$t('gwa.alt.tvapp.wa_label_3', { var1 : appStar(item.avgSscr) })">
                                            <span class="label-tit">{{ $t("sdp.store.message.rating") }}</span>
                                            <span class="label">{{ appStar(item.avgSscr) }}</span>
                                            <span class="rating"><span class="rating-max"></span><span class="rating-now"></span></span>
                                        </div>
                                    </div>
                                </div>
                                <!-- 2023.02.14 Mod =e-->
                                <!-- 2023.02.14 Add =s-->
                                <div class="view-header mob">
                                    <div class="tbl-wrap">
                                        <p class="thumbnail"><img :src="item.bigIconFile" :alt="$t('gwa.alt.tvapp.wa_etc_1', { var1 : item.appName })" onerror="imageResize.reset(this)" /></p>
                                        <div class="tbl-type2">
                                            <div class="section-header">
                                                <!-- E : 2022.02.15 Add - 모바일용 앱 아이콘 추가(view-header 영역 이미지값 동일하게 적용) -->
                                                <div class="inner">
                                                    <!--
                                                        고도화 ver2 - 카테고리별 아이콘 추가
                                                        ico-category1 게임
                                                        ico-category2 엔터테인먼트
                                                        ico-category3 생활
                                                        ico-category4 어학/교육
                                                        ico-category5 뉴스/정보
                                                    -->
                                                    <div class="iconbox">
                                                        <!-- 2024.06.10 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년 -->
                                                        <i v-for="feat in featureList" :class="'ico ico-category'+feat.icoType">{{ getFeatIconText(feat.icoType)}}</i>
                                                    </div>
                                                    <h3 class="tit-h3 tvappTitle"><span role="text">{{ item.appName }}</span></h3>
                                                </div>
                                            </div>
                                            <div class="mob-infobox">
                                                <p class="mob-infoVersion">Version {{ item.appVer }}</p>
                                                <p class="mob-infoTxt">{{ item.rcntAprlDate }}</p>
                                            </div>
                                        </div>
                                        <!-- <div class="explain-footer">
                                            <div class="bul bul-bill">
                                                <p>국가에 따라 일부 모델은 서비스가 지원되지 않을 수 있으며, 모델에 따라 지원되는 앱이 다를 수 있습니다.</p>
                                            </div>
                                        </div> 2022.06.21 Del -->
                                    </div>
                                    <div class="view-table mob">
                                        <table>
                                            <colgroup>
                                                <col width="30%">
                                                <col width="20%">
                                                <col width="30%">
                                                <col width="20%">
                                            </colgroup>
                                            <caption>
                                                <strong>{{ $t("gwa.alt.common.wa_caption_5", { var1 : item.appName }) }}</strong>
                                                <p>{{ $t("gwa.alt.common.wa_summary_5_mob") }}</p>
                                            </caption>
                                            <thead>
                                            <tr>
                                                <th scope="col">{{ $t("sdp.store.message.rating") }}</th>
                                                <th scope="col">{{ $t("sdp.store.message.age") }}</th>
                                                <th scope="col">{{ $t("sdp.store.message.category") }}</th>
                                                <th scope="col">{{ $t("sdp.store.message.size") }}</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <div class="starRating-cate">
                                                        <div class="js starRating-label" role="text" aria-valuemax="5" aria-valuemin="0" :aria-valuenow="appStar(item.avgSscr)" :aria-label="$t('gwa.alt.tvapp.wa_label_3', { var1 : appStar(item.avgSscr) })">
                                                            <!-- <span class="label-tit">평점</span> -->
                                                            <span class="label">{{ appStar(item.avgSscr) }}</span>
                                                            <span class="rating"><span class="rating-max"></span><span class="rating-now"></span></span>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <p class="tb_ctxt" v-if="cntryCode == 'BR' && item.age == '4'">{{ item.ageBr }}</p>
                                                    <p class="tb_ctxt" v-else>{{ item.appAge }}</p>
                                                </td>
                                                <td>
                                                    <p class="tb_ctxt">{{ item.cat }}</p>
                                                </td>
                                                <td>
                                                    <p class="tb_ctxt mb" v-html="fileSizeReplace(item.appFileSize)"></p>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <!-- 2023.02.14 Add =e-->
                                <!-- //주요정보 -->

                                <!-- 상세정보 -->
                                <!-- 2023.02.14 Mod =s-->
                                <div class="view-body">
                                    <div class="tab-wrap">
                                        <div class="tab-header">
                                            <div class="tab-headerTxtbox">
                                                <!-- REQSDP-10103 : 2026.03.10 송준형 - [pcmall] ru.lgappstv.com 러시아 자국어 강화법_영문 텍스트, 이미지 교체건 -->
                                                <p class="tab-headerTxt" v-if="cntryCode != 'RU'">OVERVIEW</p>
                                                <p class="tab-headerTxt" v-else>Обзор</p>
                                            </div>
                                        </div>
                                        <!-- <div class="tab-nav tab-type3 tab-change">
                                            <ul class="tablist">
                                                <li role="presentation" class="is-active"><a href="#tabViewCont1" id="tabViewNav1" role="tab" aria-controls="tabViewCont1" aria-selected="true">OVERVIEW</a></li>
                                            </ul>
                                        </div> -->
                                        <div class="tab-body">
                                            <!-- 탭내용1 -->
                                            <div id="tabViewCont1" class="tab-content is-active" role="tabpanel" aria-labelledby="tabViewNav1" aria-hidden="false">
                                                <p class="blind dv-pc-only">{{ $t('sdp.store.message.overview') }}</p>
                                                <!-- DESCRIPTION -->
                                                <div class="view-section view-description">
                                                    <h4 class="tit-h4">{{ $t("sdp.store.message.description") }}</h4>
                                                    <div class="data-content borbline" role="text">
                                                        <p class="para" v-html="lineBreakCntt(item.detailExpln)"></p>
                                                    </div>
                                                </div>
                                                <!-- //DESCRIPTION -->

                                                <!-- S : 2022.06.21 앱 지원 TV 정보 -->
                                                <div class="view-section view-description">
                                                    <h4 class="tit-h4">{{ $t('sdp.store.message.guide.001', { var1 : item.appName }) }}</h4>
                                                    <div class="data-content acodion" role="text">
                                                        <div class="acodionWrap">
                                                            <p class="para acod" style="color:#a50034 !important;">
                                                                <template v-for="(plfm, index) in plfmInfo">
                                                                    <template v-if="index == (plfmInfo.length - 1)">{{ $t('sdp.store.message.guide.002', { var1 : plfm.year, var2 : plfm.name }) }}</template>
                                                                    <template v-else>{{ $t('sdp.store.message.guide.002', { var1 : plfm.year, var2 : plfm.name }) }}, </template>
                                                                </template>
                                                            </p>
                                                            <br>
                                                            <p class="para">{{ $t("sdp.store.message.guide.003") }}</p>
                                                            <br>
                                                            <p class="para">
                                                                {{ $t("sdp.store.message.guide.004") }}
                                                                <a href="javascript:;" style="text-decoration: underline;" :aria-label="$t('gwa.alt.store.message.guide.001')" @click="goTvappSearch()">{{ $t("sdp.store.message.guide.005") }}</a>
                                                                {{ $t("sdp.store.message.guide.006") }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <button class="acodionBtn">{{ $t("sdp.store.message.showdescription") }} <span>></span></button>
                                                </div>

                                                <div class="view-event">
                                                    <div class="view-section view-eventContents">
                                                        <!-- <h4 class="tit-h4">SCREENSHOTS</h4> -->
                                                        <div class="swiper-wrap swiper-eventContents">
                                                            <!-- 상세그룹  -->
                                                            <!--  대체텍스트 형식 : alt="[앱 제목] + Screenshots + [Index]" -->
                                                            <!-- 고도화 ver2 : 태그 zommer링크처리 -->
                                                            <div class="swiper-container">
                                                                <div class="swiper-wrapper">
                                                                    <div class="swiper-slide" v-for="(banner, index) in bannerList">
                                                                        <a href="javascript:;" @click="bannerClick(banner.lnkUrl)"><img :src="banner.imgFile" :alt="$t('gwa.alt.tvapp.detail.title.001', { var1 : (index+1) })" /></a>
                                                                    </div>
                                                                    <!-- <div class="swiper-slide"><a href="javascript:;" data-src="/upload/@tvapp_screenshots_1.jpg" onclick="zommer.open(this); return false"><img src="../upload/@tvapp_screenshots_1.jpg" alt="2084 Maniac Screenshots 4" /></a></div> -->
                                                                    <!-- <div class="swiper-slide"><a href="javascript:;" data-src="/upload/@tvapp_screenshots_1.jpg" onclick="zommer.open(this); return false"><img src="../upload/@tvapp_screenshots_1.jpg" alt="2084 Maniac Screenshots 5" /></a></div> -->
                                                                </div>
                                                            </div>
                                                            <button type="button" class="swiper-button-prev"></button>
                                                            <button type="button" class="swiper-button-next"></button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class=""></div>
                                                <!-- E : 2022.06.21 앱 지원 TV 정보 -->
                                                <div class="view-appstar">
                                                    <div class="view-appwrap">
                                                        <div class="view-appinfo">
                                                            <h4 class="tit-h4">{{ $t("sdp.store.message.appinfo") }}</h4>
                                                            <ul>
                                                                <li class="applist">
                                                                    <p class="appinfo-tit">{{ $t("sdp.store.message.age") }}</p>
                                                                    <p class="appinfo-txt" v-if="cntryCode == 'BR' && item.age == '4'">{{ item.ageBr }}</p>
                                                                    <p class="appinfo-txt" v-else>{{ item.appAge }}</p>
                                                                </li>
                                                                <li class="applist">
                                                                    <p class="appinfo-tit">{{ $t("sdp.store.message.version") }}</p>
                                                                    <p class="appinfo-txt">{{ item.appVer }}</p>
                                                                </li>
                                                                <li class="applist">
                                                                    <p class="appinfo-tit">{{ $t("sdp.store.message.updated") }}</p>
                                                                    <p class="appinfo-txt">{{ item.rcntAprlDate }}</p>
                                                                </li>
                                                                <li class="applist">
                                                                    <p class="appinfo-tit">{{ $t("sdp.store.message.size") }}</p>
                                                                    <p class="appinfo-txt" v-html="fileSizeLineReplace(item.appFileSize)"></p>
                                                                </li>
                                                                <li class="applist">
                                                                    <p class="appinfo-tit">{{ $t("sdp.store.message.language") }}</p>
                                                                    <p class="appinfo-txt">{{ appSuptLangName }}</p>
                                                                </li>
                                                                <li class="applist">
                                                                    <p class="appinfo-tit">{{ $t("sdp.store.message.category") }}</p>
                                                                    <p class="appinfo-txt">{{ item.cat }}</p>
                                                                </li>
                                                                <li class="applist">
                                                                    <p class="appinfo-tit">{{ $t("sdp.store.message.seller") }}</p>
                                                                    <p class="appinfo-txt">{{ item.sellrUsrName }}</p>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div class="view-starating">
                                                        <div class="ratings-title">
                                                            <h4 class="tit-h4">{{ $t("sdp.store.message.starscorerating") }}</h4>
                                                            <p class="explain-h4"><strong>{{ $t("sdp.store.message.ratinginfo") }}</strong></p>
                                                        </div>
                                                        <!-- 만족도평가 -->
                                                        <!-- 개발참고사항
                                                            <legend> 텍스트 : [앱제목] + APP 만족도 평가 (형식으로 제공)
                                                            <button> 타이틀 : [앱제목] + APP 만족도 평가하기 (형식으로 제공)
                                                        -->
                                                        <div class="ratings-content">
                                                            <div class="ratings-inner">
                                                                <fieldset class="ratings-score">
                                                                    <legend>{{ $t("gwa.alt.tvapp.wa_etc_4", { var1 : item.appName }) }}</legend>
                                                                    <div class="rating-boxwrap">
                                                                        <div class="rating-btnbox">
                                                                            <!-- 2024.06.10 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년 -->
                                                                            <!-- 2024.06.21 송준형 : REQSDP-5357 - PC Mall 웹접근성 심사결과대응 2차 -->
                                                                            <!-- 2024.07.01 송준형 : REQSDP-5378 - PC Mall 웹접근성 심사결과대응 3차 -->
                                                                            <button class="rating-btn"  data-idx="1" id="ratingBtn1" @click="selectStar('1')"><span class="blind">{{ $t('gwa.alt.common.wa_label_4', { var1 : 1 }) }}</span></button>
                                                                            <button class="rating-btn"  data-idx="2" id="ratingBtn2" @click="selectStar('2')"><span class="blind">{{ $t('gwa.alt.common.wa_label_4', { var1 : 2 }) }}</span></button>
                                                                            <button class="rating-btn"  data-idx="3" id="ratingBtn3" @click="selectStar('3')"><span class="blind">{{ $t('gwa.alt.common.wa_label_4', { var1 : 3 }) }}</span></button>
                                                                            <button class="rating-btn"  data-idx="4" id="ratingBtn4" @click="selectStar('4')"><span class="blind">{{ $t('gwa.alt.common.wa_label_4', { var1 : 4 }) }}</span></button>
                                                                            <button class="rating-btn"  data-idx="5" id="ratingBtn5" @click="selectStar('5')"><span class="blind">{{ $t('gwa.alt.common.wa_label_4', { var1 : 5 }) }}</span></button>
                                                                        </div>
                                                                        <div class="rating-chk" data-grade="0"></div>
                                                                        <div class="rating-hovchk" data-hover="0"></div>
                                                                    </div>
                                                                </fieldset>
                                                                <div class="ratings-btn">
                                                                    <button @click="goEstimate()" type="button" class="btn btn-type8" :class="estimatePopup" :title="$t('gwa.alt.common.wa_title_30', { var1 : item.appName })" aria-controls="popupStarRating" aria-haspopup="true"><span>{{ $t("sdp.store.message.starscorerating") }}</span></button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- //만족도평가 -->
                                                    </div>
                                                    <!-- //RAINGS -->
                                                </div>
                                            </div>
                                            <!-- //탭내용1 -->
                                            <!-- 탭내용2 -->
                                            <!-- start-2022.06.21 송준형 : REQSDP-1633 - LG Content Store(웹사이트) 내 App별 지원 플랫폼 표기 기획 -->
                                            <!--<div id="tabViewCont2" class="tab-content" aria-hidden="true">-->
                                                <!--<p class="blind dv-pc-only">{{ $t('sdp.store.message.devicecompatibility') }}</p>-->
                                                <!--&lt;!&ndash; 호환기기 전체영역 &ndash;&gt;-->
                                                <!--&lt;!&ndash; 고도화 ver1 : 로그인전, 후 클래스 적용 &ndash;&gt;-->
                                                <!--<div class="compatible-wrap" :class="isLoginYn">&lt;!&ndash; 로그인전 : is-loginBefore, 로그인후 : is-loginAfter &ndash;&gt;-->
                                                    <!--&lt;!&ndash; 로그인확인 &ndash;&gt;-->
                                                    <!--<div class="compatible-container">-->
                                                        <!--&lt;!&ndash; 로그인전 &ndash;&gt;-->
                                                        <!--<div class="login-before">-->
                                                            <!--<div class="compatible-header" v-html="$t('sdp.store.message.devicecompatibility_login')"></div>-->
                                                            <!--<div class="compatible-body">-->
                                                                <!--<div class="inner">-->
                                                                    <!--<i class="ico ico-sd-1" aria-hidden="true"></i>-->
                                                                    <!--<div class="para-wrap" v-html="$t('sdp.store.message.devicecompatibility_logindetail')"></div>-->
                                                                <!--</div>-->
                                                            <!--</div>-->
                                                            <!--<div class="compatible-footer">-->
                                                                <!--<button @click="goLgaccount()" type="button" class="btn btn-type8"><span>{{ $t('sdp.menu.gnb.lgaccount') }}</span></button>-->
                                                            <!--</div>-->
                                                        <!--</div>-->
                                                        <!--&lt;!&ndash; //로그인전 &ndash;&gt;-->

                                                        <!--&lt;!&ndash; 로그인후 &ndash;&gt;-->
                                                        <!--<div v-if="appMyDvcCompatibility == 'ACT_DVC'" class="login-after">-->
                                                            <!--<div class="compatible-header" v-html="$t('sdp.store.message.devicecompatibility_noact')"></div>-->
                                                            <!--<div class="compatible-body">-->
                                                                <!--<div class="inner">-->
                                                                    <!--<i class="ico ico-sd-2" aria-hidden="true"></i>-->
                                                                    <!--<div class="para-wrap" v-html="$t('sdp.store.message.devicecompatibility_noactdetail')">-->
                                                                        <!--&lt;!&ndash;<p class="para">고객님의 디바이스에서 <em class="color-primary">동일한 ID</em>로 로그인하신 이력이 있는 경우에만,<br>실행 기능 여부를 확인하실 수 있습니다.</p>-->
                                                                        <!--<p class="para">고객님의 디바이스에서 <em class="color-primary">로그인</em> 후, 재확인 해주세요.</p>&ndash;&gt;-->
                                                                    <!--</div>-->
                                                                <!--</div>-->
                                                            <!--</div>-->
                                                        <!--</div>-->
                                                        <!--<div v-else-if="appMyDvcCompatibility == 'Y'" class="login-after">-->
                                                            <!--<div class="compatible-header"></div>-->
                                                            <!--<div class="compatible-body">-->
                                                                <!--<div class="inner">-->
                                                                    <!--<i class="ico ico-sd-4" aria-hidden="true"></i>-->
                                                                    <!--<div class="para-wrap" v-html="$t('sdp.store.message.devicecompatibility_y')"></div>-->
                                                                <!--</div>-->
                                                            <!--</div>-->
                                                        <!--</div>-->
                                                        <!--<div v-else-if="appMyDvcCompatibility == 'Y2'" class="login-after">-->
                                                            <!--<template v-if="diffOwnedDvcUseDvcYn == 'Y'">-->
                                                                <!--<div v-if="appUseModelName == 'Unknown'" class="compatible-header" v-html="$t('sdp.store.message.devicecompatibility_y2')"></div>-->
                                                                <!--<div v-else class="compatible-header" v-html="$t('sdp.store.message.devicecompatibility_y2_in1', { var1 : appUseModelName })"></div>-->
                                                            <!--</template>-->
                                                            <!--<template v-else>-->
                                                                <!--<div class="compatible-header" v-html="$t('sdp.store.message.devicecompatibility_y2')"></div>-->
                                                            <!--</template>-->
                                                            <!--<div class="compatible-body">-->
                                                                <!--<div class="inner">-->
                                                                    <!--<i class="ico ico-sd-5" aria-hidden="true"></i>-->
                                                                    <!--<template v-if="diffOwnedDvcUseDvcYn == 'Y'">-->
                                                                        <!--<div v-if="appUseModelName == 'Unknown'" class="para-wrap" v-html="$t('sdp.store.message.devicecompatibility_y2detail')">-->
                                                                            <!--{{ $t("sdp.store.message.devicecompatibility_y2detail") }}-->
                                                                        <!--</div>-->
                                                                        <!--<div v-else class="para-wrap" v-html="$t('sdp.store.message.devicecompatibility_y2_in1detail', { var1 : appUseModelName })"></div>-->
                                                                    <!--</template>-->
                                                                    <!--<template v-else>-->
                                                                        <!--<div class="para-wrap" v-html="$t('sdp.store.message.devicecompatibility_y2detail')"></div>-->
                                                                    <!--</template>-->
                                                                <!--</div>-->
                                                            <!--</div>-->
                                                        <!--</div>-->
                                                        <!--<div v-else class="login-after">-->
                                                            <!--<div class="compatible-header"></div>-->
                                                            <!--<div class="compatible-body">-->
                                                                <!--<div class="inner">-->
                                                                    <!--<i class="ico ico-sd-3" aria-hidden="true"></i>-->
                                                                    <!--<div class="para-wrap" v-html="$t('sdp.store.message.devicecompatibility_n')"></div>-->
                                                                <!--</div>-->
                                                            <!--</div>-->
                                                        <!--</div>-->
                                                        <!--&lt;!&ndash; //로그인후 &ndash;&gt;-->
                                                    <!--</div>-->
                                                    <!--&lt;!&ndash; //로그인확인 &ndash;&gt;-->

                                                    <!--&lt;!&ndash; 호환정보 &ndash;&gt;-->
                                                    <!--<div class="compatible-area">-->
                                                    <!--</div>-->
                                                    <!--&lt;!&ndash; //호환정보 &ndash;&gt;-->
                                                <!--</div>-->
                                                <!--&lt;!&ndash; //호환기기 전체영역 &ndash;&gt;-->
                                            <!--</div>-->
                                            <!-- end-2022.06.21 송준형 : REQSDP-1633 - LG Content Store(웹사이트) 내 App별 지원 플랫폼 표기 기획 -->
                                            <!-- //탭내용2 -->
                                        </div>
                                    </div>
                                </div>
                                <!-- //상세정보 -->
                            </div>
                            <!-- //앱상세 전체영역 -->

                            <!-- 앱상세 버튼영역 -->
                            <div class="view-app-btn">
                                <!-- 2024.06.14 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년 -->
                                <button @click="goTvapp()" type="button" class="btn btn-type9" :title="$t('gwa.alt.common.wa_label_24')"><span>{{ $t("sdp.support.message.listview") }}</span></button>
                            </div>
                            <!-- //앱상세 버튼영역 -->
                        </div>
                    </section>
                    <!-- //상세섹션 -->

                    <!-- 미등록게시물 -->
                    <div class="noData-wrap" v-if="prodInfo.length == 0">
                        <div class="noData">
                            <div class="inner">
                                <p><i class="ico ico-waring2"></i><span class="noData-txt">No Application Contents</span></p>
                            </div>
                        </div>
                    </div>
                    <!-- //미등록게시물 -->

                    <!-- 관련정보 -->
                    <div class="box-wrap box-relateMenu">
                        <div class="box">
                            <div class="box-header">
                                <p class="para">{{ $t('sdp.self.message.title2') }}</p>
                            </div>
                            <div class="box-body">
                                <div class="grid grid-divieder">
                                    <div class="col col-6">
                                    	<!-- N20190710_04315-PC 웹사이트 1:1문의 화면 이슈(1:1문의) 2019.07.11 김남중 -->
                                        <!-- <router-link to="/main/inquiry/register" tag="a" v-show="loginYn" href="javascript:;" class="relate-link"> -->
                                        <router-link to="/main/inquiry/register" class="relate-link">
                                            <span class="ico-area" aria-hidden="true"><i class="ico ico-ques"></i></span>
                                            <dl>
                                                <dt class="tit">{{ $t('sdp.store.message.quickmenu1') }}</dt>
                                                <dd class="txt" v-html="$t('sdp.support.message.new.qna4')"></dd>
                                            </dl>
                                        </router-link>
                                        <!-- N20190710_04315-PC 웹사이트 1:1문의 화면 이슈(1:1문의-팝업2번떠서주석처리) 2019.07.11 김남중 -->
                                        <!-- <a v-show="!loginYn" href="javascript:;" class="relate-link popup-open" aria-controls="popupConfirm" aria-haspopup="true">
                                            <span class="ico-area" aria-hidden="true"><i class="ico ico-ques"></i></span>
                                            <dl>
                                                <dt class="tit">{{ $t('sdp.store.message.quickmenu1') }}</dt>
                                                <dd class="txt" v-html="$t('sdp.support.message.new.qna4')"></dd>
                                            </dl>
                                        </a> -->
                                    </div>
                                    <div class="col col-6">
                                        <router-link to="/main/faq?catCode1=1004" tag="a" href="javascript:;" class="relate-link">
                                            <span class="ico-area" aria-hidden="true"><i class="ico ico-faq"></i></span>
                                            <dl>
                                                <dt class="tit">{{ $t('sdp.store.message.quickmenu2') }}</dt>
                                                <dd class="txt" v-html="$t('sdp.faq.message.title')"></dd>
                                            </dl>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- //관련정보 -->
                </div>
            </div>
            <!-- //탭메뉴 -->

            <!-- ScreenShot Zommer -->
            <div class="zommer-wrap" onclick="zommer.close(this)">
                <span class="zommer-body">
                    <img src="" class="zommer-img" alt="">
                    <a href="javascript:;" class="btn-ico btn-close" onclick="zommer.close(this);"><i class="ico ico-close-zommer">{{ $t('gwa.alt.common.wa_label_26') }}</i></a>
                </span>
            </div>
            <!-- //ScreenShot Zommer -->

            <!-- 팝업_별점평가 -->
            <div id="popupStarRating" class="popup-wrap" hidden>
                <div class="popup popup-type1" role="dialog" aria-labelledby="popupStarRatingTitle">
                    <div class="blind-area popup-focus dv-ios-only" role="text" :aria-label="$t('gwa.alt.common.wa_label_54')"><!-- IOS접근성 영역자체에 초점처리 --></div>
                    <div class="popup-container">
                        <div class="popup-header">
                            <h3 class="tit-h3" id="popupStarRatingTitle">{{ $t("sdp.store.message.starscorerating") }}</h3>
                        </div>
                        <div class="popup-body popup-scroll loading-wrap" style="height: 100% !important;" v-if="estimatingYn == 'Y'">
                            <div class="loading"><img src="/img/cmn/loading.png" :alt="$t('gwa.alt.common.wa_etc_1')"></div>
                        </div>
                        <div class="popup-body popup-scroll" v-else>
                            <div class="para-wrap align-c">
                                <p class="para color-primary">{{ getEstimateStr1 }}</p>
                                <p class="para">{{ getEstimateStr2 }}</p>
                            </div>
                        </div>
                        <div class="popup-footer">
                            <div class="btn-wrap">
                                <button type="button" class="btn btn-type2 popup-close btn-secondary" aria-controls="popupStarRating" :title="$t('gwa.alt.common.wa_title_57')"><span>{{ $t("sdp.mypage.message.confirm2") }}</span></button>
                            </div>
                        </div>
                        <button type="button" class="btn-ico btn-popup-close popup-close" aria-controls="popupStarRating" :title="$t('gwa.alt.common.wa_title_57')"><span><i class="ico ico-close2">{{ $t('gwa.alt.common.wa_label_19') }}</i></span></button>
                    </div>
                </div>
            </div>
            <!-- //팝업_별점평가 -->

            <!-- 모달팝업_문의확인 -->
            <InquiryConfirmPop></InquiryConfirmPop>
            <!-- //모달팝업_문의확인 -->

            <div id="popupTabSelect" class="popup-wrap popup-select" role="dialog">
                <div class="popup popup-tab">
                    <nav class="tab-nav tab-type1 tab-responsive">
                        <ul role="tablist">
                            <li role="presentation" :class="{'is-active' : isTabActive('')}" v-show="appCateList.length > 0">
                                <a href="javascript:;" role="tab" aria-selected="true" @click="goAllSearch()">
                                    <span class="tit">{{ $t("sdp.mypage.message.tabbuyall") }}</span>
                                </a>
                            </li>
                            <li v-for="item in appCateList" role="presentation" :class="{'is-active' : isTabActive(item.catCode)}">
                                <a href="javascript:;" role="tab" aria-selected="false" @click="goTabSearch(item.catCode, item.catName)">
                                    <span class="tit">{{ item.catName }}<em class="label-type2">{{ item.cnt }}</em></span>
                                </a>
                            </li>
                        </ul>
                    </nav>
                    <button type="button" class="btn-ico btn-close-select" aria-controls="popupTabSelect"><span><i class="ico ico-close2">{{ $t('gwa.alt.common.wa_label_22') }}</i></span></button>
                </div>
            </div>
            
			<!-- 팝업_FR국가 법적고지(NOTES JURIDIQUES) PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중 -->
			<div v-show="cntryCode == 'FR'">
				<TermsPop></TermsPop>
			</div>
			<!-- //팝업_FR국가 법적고지(NOTES JURIDIQUES) PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중 -->
		
        </div>
        <!-- //Content Body -->
    </section>
    <!-- //Content -->
</template>

<script>
    import qs from "qs";
    import InquiryConfirmPop from '@/components/inquiry/InquiryConfirmPop';
    import TermsPop from '@/components/terms/TermsPop';

    export default {
        name: "Tvapp",
        components: {
            InquiryConfirmPop,
            TermsPop //PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중
        },
        data() {
            return {
                appId: "",
                appCateList: [],
                prodInfo: [],
                plfmInfo: [], // 2022.06.20 송준형 : REQSDP-1633 - LG Content Store(웹사이트) 내 App별 지원 플랫폼 표기 기획
                bannerList: [], // 2023.06.07 송준형 : REQSDP-1851 - [pcmall]앱 상세정보 영역 변경_pc_webiste
                domainPrefix : "", // 2023.06.07 송준형 : REQSDP-1851 - [pcmall]앱 상세정보 영역 변경_pc_webiste
                appSuptLangName: "",
                screenShotList: [],
                featureList: [],
                appMyDvcCompatibility: "",
                appUseModelName: "",
                diffOwnedDvcUseDvcYn: "",
                loginYn: false,
                host: "",
                estimated: "",
                catCode1: "",
                moreYn: "N",
                cateYn: "N",
                loadingYn: "Y",
                estimatingYn: "N",
                starScr: "0",
                estimateType: "",
                orderType: "0",
                headerName: "",
                appRankCode: "",
                sellrUsrNo: "",
                curPage: 1,
                appSearchYn: "N", // 2021.10.19 송준형 : REQSDP-842 - PC Mall 내 모델명 기준 앱 조회기능 개발 요청
                cntryCode: _domainCntryCode, //2019.11.28 김남중 - C20191125_30416: PC Mall TVapp 별점평가에 </br>태그 노출
                searchCntryCode: ""
            }
        },
        methods: {
            track () {
				console.log('@@@@ track:', this.$router.currentRoute.path);
				this.$ga.page(this.$router.currentRoute.path)
			},
            goAllSearch() {
                const r = { path : "/main/tvapp?catCode1=&moreYn=N&cateYn=N&orderType=0"
                        + "&headerName=&appRankCode=&curPage=1&detailYn=Y" };
                this.$router.push(r);
            },
            goTabSearch(catCode1, catName) {
                const r = { path : "/main/tvapp?catCode1=" + catCode1 + "&moreYn=N&cateYn=Y&orderType=0&headerName="
                        + catName + "&appRankCode=&curPage=1&detailYn=Y" };
                this.$router.push(r);
            },
            goTvapp() {
                // start-2021.10.19 송준형 : REQSDP-842 - PC Mall 내 모델명 기준 앱 조회기능 개발 요청
                if(this.sellrUsrNo != "") {
                    const r = { path : "/main/tvapp/seller?sellrUsrNo=" + this.sellrUsrNo
                            + "&curPage=" + this.curPage };
                    this.$router.push(r);
                } else if(this.appSearchYn == "Y") {
                    const r = { path : "/main/tvapp" };
                    this.$router.push(r);
                } else {
                    const r = { path : "/main/tvapp?catCode1=" + this.catCode1 + "&moreYn=" + this.moreYn
                            + "&cateYn=" + this.cateYn + "&orderType=" + this.orderType + "&headerName="
                            + this.headerName + "&appRankCode=" + this.appRankCode + "&curPage="
                            + this.curPage + "&detailYn=Y" };
                    this.$router.push(r);
                }
                // end-2021.10.19 송준형 : REQSDP-842 - PC Mall 내 모델명 기준 앱 조회기능 개발 요청
            },
            selectStar(score) { // 2024.06.21 송준형 : REQSDP-5357 - PC Mall 웹접근성 심사결과대응 2차
                this.starScr = score * 2;

                for(var i = 1; i < 6; i++) {
                    var ratingBtnId = "#ratingBtn" + i;
                    if(i == score) { // 2024.07.01 송준형 : REQSDP-5378 - PC Mall 웹접근성 심사결과대응 3차
                        $(ratingBtnId).attr("title", this.$t("gwa.alt.tvapp.detail.title.002"));
                    } else {
                        $(ratingBtnId).removeAttr("title");
                    }
                }
            },
            goEstimate() {
                const vm = this;

                if(vm.loginYn) {
                    vm.goEstimateAjax();
                } else {
                    vm.goLgaccount();
                }
            },
            goEstimateAjax() {
                const vm = this;
                vm.estimateType = "";

                if(vm.starScr != "") {
                    ui.loading.open();
                    vm.estimatingYn = "Y";

                    const params = {
                        appId: vm.appId,
                        starScr: vm.starScr
                    };

                    this.$axios.post("/api/tvapp/createProductEstimate.ajax",
                        qs.stringify(params)).then((result) => {
                        ui.loading.close();
                        vm.estimateType = result.data.estimateType;
                        vm.estimatingYn = "N";
                        /*vm.$nextTick(function() {
                            ui.init();
                        });*/
                    }).catch((err) => {
                        ui.loading.close();
                        vm.estimatingYn = "N";
                        alert("error : " + err);
                    });
                } else {
                    vm.estimateType = "NOSTAR";
                    vm.estimatingYn = "N";
                }
            },
            setProdInfoResult(result) {
                const vm = this;

                vm.prodInfo = result.data.prodInfo;
                vm.plfmInfo = result.data.plfmInfo; // 2022.06.20 송준형 : REQSDP-1633 - LG Content Store(웹사이트) 내 App별 지원 플랫폼 표기 기획
                vm.bannerList = result.data.bannerList; // 2023.06.07 송준형 : REQSDP-1851 - [pcmall]앱 상세정보 영역 변경_pc_webiste
                vm.domainPrefix = result.data.domainPrefix; // 2023.06.07 송준형 : REQSDP-1851 - [pcmall]앱 상세정보 영역 변경_pc_webiste
                vm.appSuptLangName = result.data.appSuptLangName;
                vm.screenShotList = result.data.screenShotList;
                vm.featureList = result.data.featureList;
                vm.appMyDvcCompatibility = result.data.appMyDvcCompatibility;
                vm.appUseModelName = result.data.appUseModelName;
                vm.diffOwnedDvcUseDvcYn = result.data.diffOwnedDvcUseDvcYn;
                vm.host = result.data.input.host;
                vm.estimated = result.data.input.estimated;
                vm.cntryCode = result.data.input.cntryCode;
                vm.loadingYn = "N";

                // start-2025.11.19 송준형 : REQSDP-9056 - 정적 developer_url META tag 적용
                if($("meta[name='appstore:developer_url']").attr("content") == "") {
                      var devUrl = result.data.devUrl;
                      if(devUrl != null && devUrl != "") {
                          if(devUrl.indexOf("|") != -1) {
                              $("meta[name='appstore:developer_url']").attr("content", devUrl.split("|")[0]);
                              $("meta[name='appstore:bundle_id']").attr("content", devUrl.split("|")[1]);
                          } else {
                              $("meta[name='appstore:developer_url']").attr("content", devUrl);
                              $("meta[name='appstore:bundle_id']").attr("content", vm.appId);
                          }
                          $("meta[name='appstore:store_id']").attr("content", vm.appId);
                      }
                }
                /*else {
                    $("meta[name='appstore:developer_url']").remove();
                    $("meta[name='appstore:bundle_id']").remove();
                    $("meta[name='appstore:store_id']").remove();
                }*/
                // end-2025.11.19 송준형 : REQSDP-9056 - 정적 developer_url META tag 적용

                vm.$nextTick(function() {
                    ui.init();
                    loadSelected();
                });
            },
            goLgaccount() {
                const vm = this;

                var _params = {
                    appId: vm.appId,
                    catCode1: vm.catCode1,
                    moreYn: vm.moreYn,
                    cateYn: vm.cateYn,
                    orderType: vm.orderType,
                    headerName: vm.headerName,
                    appRankCode: vm.appRankCode,
                    sellrUsrNo: vm.sellrUsrNo,
                    curPage: vm.curPage
                };

                // 2024.12.17 송준형 : REQSDP-6333 - PCMall LMP(멤버스) 로그인 연동 방식 개선 개발
                var loginPath = "tvapp/detail?" + qs.stringify(_params);
                const r = { path : "/main/loginLink?path=" + loginPath.replaceAll("&", "-") };
                this.$router.push(r);
            },
            bannerClick(url) {
                if (url == null || url == '') {
                    return;
                } else {
                    // [START] C20200921_05798 : PC Website Promotion Banner 기간 설정 기능 추가, 사용성 현황(클릭수) 추가 - 2020.09.07 송준형
                    var bannerUrl = "https://" + this.domainPrefix + this.cntryCode + ".lgappstv.com/main/bannerLink?";
                    bannerUrl += "bannerUrl=" + encodeURIComponent(url) + "&bannerType=tvapp";
                    // [END] C20200921_05798 : PC Website Promotion Banner 기간 설정 기능 추가, 사용성 현황(클릭수) 추가 - 2020.09.07 송준형

                    //window.open(url, '_blank');
                    // start- C20190723_47503 : 2019.08.08 김남중 - 옴니추어 Main Swiper 배너 이미지 Link
                    const params = {
                        url: bannerUrl,
                        banner: 'banner'
                    };

                    // window navigator
                    var userAgent = window.navigator.userAgent;
                    var isChrome = userAgent.indexOf('Chrome');
                    var isChromeMobile = userAgent.indexOf('CriOS');
                    var isSamsungBrowser = userAgent.indexOf('SamsungBrowser');
                    var isFirefox = userAgent.indexOf('Firefox');
                    var isEdge = userAgent.indexOf('Edge');
                    var browse = userAgent.toLowerCase();
                    var isIe = browse.indexOf("msie");
                    var isIeMinu = browse.indexOf("trident");
                    // window Open
                    // - Chrom/Firefox의 경우 간혹 "domain/_blank"로 되어 not found 후 emp이용약관으로 이동하여 현재 페이지open 후 이동하도록 처리함.
                    // - PC 익스플로러는 팝업차단 우회 막혀서 안됨.
                    var popWindow;
                    var baseWinurl = window.location;
                    //console.log("baseWinurl:", baseWinurl.origin);
                    if ((navigator.appName == 'Netscape' && isIeMinu > -1) || isIe > -1) {}
                    else if (isSamsungBrowser > -1) { popWindow = window.open(); }
                    else if (isChrome > -1 || isFirefox > -1) { popWindow = window.open(baseWinurl, '_blank'); }
                    else { popWindow = window.open('_blank'); }

                    this.$axios.post('', qs.stringify(params)).then((result) => {
                        // C20190819_65828 : 2019.08.22 김남중 - PC Website Main Promotion Banner 링크 오류 수정
                        //                   - this.$axios.post('main:banner', 와 window.open(url, '_blank') 변경
                        //window.open(url, '_blank');
                        /* var popWindow = window.open('_blank');
                        popWindow.location.href = url; */
                        // 브라우저 체크(IE의 경우 팝업 우회불가함.)
                        if ((navigator.appName == 'Netscape' && isIeMinu > -1) || isIe > -1) {
                            window.open(bannerUrl, '_blank');
                        } else {
                            //var popWindow = window.open('_blank');
                            popWindow.location.href = bannerUrl;
                        }
                        /* // pc, mobile의 크롬 브라우저 체크 //var isWindows = userAgent.indexOf('Windows NT'); //var isIE = userAgent.indexOf('Trident');
                           var userAgent = window.navigator.userAgent; var isChrome = userAgent.indexOf('Chrome'); var isChromeMobile = userAgent.indexOf('CriOS'); var isSamsungBrowser = userAgent.indexOf('SamsungBrowser'); var isEdge = userAgent.indexOf('Edge');
                           // 크롬 브라우저 체크
                           if (isChrome > -1 || isChromeMobile > -1) { if (isSamsungBrowser < 0 && isEdge < 0) { //setTimeout(function() { popWindow.close(); }, 500); } } */
                    }).catch((err) => {
                        alert("error : " + err);
                    });
                    // end- C20190723_47503 : 2019.08.08 김남중 - 옴니추어 Main Swiper 배너 이미지 Link
                }
            },
            appStar(avgSscr) {
                if (avgSscr >= 9.5) {
                    return 5;
                } else if (avgSscr >= 8.5) {
                    return 4.5;
                } else if (avgSscr >= 7.5) {
                    return 4;
                } else if (avgSscr >= 6.5) {
                    return 3.5;
                } else if (avgSscr >= 5.5) {
                    return 3;
                } else if (avgSscr >= 4.5) {
                    return 2.5;
                } else if (avgSscr >= 3.5) {
                    return 2;
                } else if (avgSscr >= 2.5) {
                    return 1.5;
                } else if (avgSscr >= 1.5) {
                    return 1;
                } else if (avgSscr >= 0.5) {
                    return 0.5;
                } else {
                    return 0;
                }
            },
            fileSizeReplace(size) {
                if(this.cntryCode == "DE") {
                    return size.replace(".", ",");
                } else {
                    return size;
                }
            },
            fileSizeLineReplace(size) {
                return this.fileSizeReplace(size.replace("<br>", " "));
            },
            lineBreakCntt(cntt) {
                if(cntt != null && cntt != "") {
                    return cntt.split("\n").join("<br />");
                } else {
                    return "";
                }
            },
            isTabActive(catCode1) {
                if(this.catCode1 == catCode1) {
                    return true;
                } else {
                    return false;
                }
            },
            getFeatIconText(icoType) { // 2024.06.18 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년
                if(icoType == "1") {
                    return "Internet";
                } else if(icoType == "2") {
                    return "3D";
                } else if(icoType == "3") {
                    return "Cam";
                } else if(icoType == "4") {
                    return "Magic R";
                } else if(icoType == "5") {
                    return "Gamepad";
                } else {
                    return "";
                }
            },
            goTvappSearch() { // 2022.06.21 송준형 : REQSDP-1633 - LG Content Store(웹사이트) 내 App별 지원 플랫폼 표기 기획
                const r = { path : "/main/appSearch"};
                this.$router.push(r);
            }
        },
        computed: {
            isLoginYn: function() {
                if(this.loginYn) {
                    return "is-loginAfter";
                } else {
                    return "is-loginBefore";
                }
            },
            estimatePopup: function() {
                if(this.loginYn) {
                    return "popup-open";
                } else {
                    return "";
                }
            },
            getEstimateStr1: function() {
                if(this.estimateType == "SUCCESS") {
                	// 2019.11.28 김남중 - C20191125_30416: PC Mall TVapp 별점평가에 </br>태그 노출
                    //return this.$t("sdp.store.message.sucestimate");
                	return this.$t("sdp.store.message.sucestimate1");
                } else if(this.estimateType == "NOBUY") {
                    return this.$t("sdp.store.message.estimatenonbuy1");
                } else if(this.estimateType == "ALREADY") {
                	// 2019.11.28 김남중 - C20191125_30416: PC Mall TVapp 별점평가에 </br>태그 노출
                    //return this.$t("sdp.store.message.alreadyestimate");
                	return this.$t("sdp.store.message.alreadyestimate1");
                } else if(this.estimateType == "ERROR") {
                    return this.$t("sdp.store.message.errestimate");
                } else if(this.estimateType == "NOSTAR") {
                    $('#popupStarRating').attr({'data-for':'sRadioStar5'});
                    return this.$t("sdp.store.message.choosestar"); //평점입력을 안한경우
                } else if(this.estimateType == "LOGIN") {
                    return this.$t("sdp.err.cm.authentication"); // 로그인이 풀린 경우
                } else {
                    return "";
                }
            },
            getEstimateStr2: function() {
                if(this.estimateType == "NOBUY") {
                    return this.$t("sdp.store.message.estimatenonbuy2");
                } else {
                	//star- 2019.11.28 김남중 - PC Mall TVapp 별점평가에 </br>태그 노출
                    //return "";
                	if (this.estimateType == "SUCCESS") {
                		return this.$t("sdp.store.message.sucestimate2");
                	} else if (this.estimateType == "ALREADY") {
                    	return this.$t("sdp.store.message.alreadyestimate2");
                	} else {
                	//end- 2019.11.28 김남중 - PC Mall TVapp 별점평가에 </br>태그 노출
                    	return "";
                	}
                }
            }
        },
        mounted() {
            const vm = this;
            ui.loading.open();

            vm.appId = vm.$route.query.appId;
            vm.catCode1 = vm.$route.query.catCode1;
            vm.moreYn = vm.$route.query.moreYn;
            vm.cateYn = vm.$route.query.cateYn;
            vm.orderType = vm.$route.query.orderType;
            vm.headerName = vm.$route.query.headerName;
            vm.appRankCode = vm.$route.query.appRankCode;
            vm.sellrUsrNo = vm.$route.query.sellrUsrNo;

            if(vm.$route.query.curPage != null && vm.$route.query.curPage != "") {
                vm.curPage = vm.$route.query.curPage;
            }

            // 2021.10.19 송준형 : REQSDP-842 - PC Mall 내 모델명 기준 앱 조회기능 개발 요청
            if(vm.$route.query.appSearchYn != null && vm.$route.query.appSearchYn != "") {
                vm.appSearchYn = vm.$route.query.appSearchYn;
            }

            if(vm.$route.query.searchCntryCode != null && vm.$route.query.searchCntryCode != "") {
                vm.searchCntryCode = vm.$route.query.searchCntryCode;
            }

            // 2021.02.05 송준형 : C20210205_77310 - PC Mall 코드 내 meta_name field 추가 요청드립니다.
            // 2021.08.10 송준형 : REQSDP-986 - PC Mall 내 LG채널 앱 Developer URL 변경 요청
            /*if((vm.cntryCode == "DE" && vm.appId == "474315") || (vm.cntryCode == "US" && vm.appId == "474301") ||
                (vm.cntryCode == "CA" && vm.appId == "474306") || (vm.cntryCode == "GB" && vm.appId == "952316") ||
                (vm.cntryCode == "BR" && vm.appId == "474310") || (vm.cntryCode == "MX" && vm.appId == "974696")) {
                $("meta[name='appstore:developer_url']").attr("content", "http://lgchannels.com");
                $("meta[name='appstore:bundle_id']").attr("content", vm.appId);
                $("meta[name='appstore:store_id']").attr("content", vm.appId);
            } else if(vm.cntryCode == "ES" && vm.appId == "329424") { // 2022.12.09 송준형 : REQSDP-2161 - [pcmall] Atresplayer 앱 상세페이지 meta tag 추가
                $("meta[name='appstore:developer_url']").attr("content", "https://www.atresplayer.com/");
                $("meta[name='appstore:bundle_id']").attr("content", vm.appId);
                $("meta[name='appstore:store_id']").attr("content", vm.appId);
            } else if(vm.cntryCode == "DE" && vm.appId == "983161") { // 2024.12.10 송준형 : REQSDP-6329 - [pcmall] Joyn 앱 상세페이지 meta tag 추가
                $("meta[name='appstore:developer_url']").attr("content", "https://www.joyn.de");
                $("meta[name='appstore:bundle_id']").attr("content", "joyn.lgsmarttv");
                $("meta[name='appstore:store_id']").attr("content", vm.appId);
            } else {
                $("meta[name='appstore:developer_url']").remove();
                $("meta[name='appstore:bundle_id']").remove();
                $("meta[name='appstore:store_id']").remove();
            }*/

            const params = {
                appId: vm.appId,
                searchCntryCode: vm.searchCntryCode
            };

            this.$axios.post("/api/tvapp/retrieveAppInfo.ajax",
                qs.stringify(params)).then((result) => {
                ui.loading.close();

                vm.appCateList = result.data.appCateList;
                vm.loginYn = result.data.loginYn;

                if(result.data.prodInfo != null) {
                    vm.setProdInfoResult(result);
                } else {
                    vm.loadingYn = "N";
                    vm.$nextTick(function() {
                        ui.init();
                    });
                }
            }).catch((err) => {
                vm.$nextTick(function() {
                    ui.loading.close();
                    vm.loadingYn = "N";
                });
                alert("error : " + err);
            });
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
